import {ActionTypeStrategy} from './action-type-strategy.interface';

export class ActionTypeContext {
  private strategy: ActionTypeStrategy;

  /**
   * Accept strategy through the constructor
   */
  constructor(strategy: ActionTypeStrategy) {
    this.strategy = strategy;
  }

  /**
   * Delegate work to strategy
   */
  public exec(): void {
    this.strategy.action();
  }
}
